// Imports
import React from "react"
import { Section, Font } from "fajny-react"

import CodeContainer from "../CodeContainer"

import { Container, DemoContainer } from "./styles"

const DemoItem = ({ demo }) => {
    const { title, content, code } = demo

    return title ? (
        <Section gap="small">
            <Font.H3>{title}</Font.H3>

            <Container>
                {content && <DemoContainer>{content}</DemoContainer>}

                {code && <CodeContainer>{code}</CodeContainer>}
            </Container>
        </Section>
    ) : (
        <Container>
            {content && <DemoContainer>{content}</DemoContainer>}

            {code && <CodeContainer>{code}</CodeContainer>}
        </Container>
    )
}

export default DemoItem
